
import Vue from 'vue';
import _ from 'lodash';
import { components } from '../page-items';

export default Vue.extend({
  // eslint-disable-next-line
  name: 'carrayGroup',
  components: {
    ...components
  },
  props: {
    group: { type: Object, default: () => {} },
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} },
    groupDisabled: { type: Boolean, default: false },
    rowDisabled: { type: Boolean, default: false }
  },
  computed: {
    initialArrayLength: function(): number {
      return isNaN(this.group.initialArrayLength) ? 1 : this.group.initialArrayLength
    },
    disabledArrayGroup: function(): boolean {
      return this.rowDisabled || this.groupDisabled || (this.input && this.parent._getDisableStatus(this.input.disabled));
    }
  },
  mounted() {
    if(this.group.initialValue) {
      const { prefix, key } = this.parent._getPrefixAndKey(this.group.variable);
      const variableExists = !!this.parent._getVariable(prefix);
      if(variableExists) {
        this.$set(this.parent._getVariable(prefix), key, this.group.initialValue);
      }
    } else {
      this._writeArrayGroupVars();
    }
  },
  methods: {
    getItems: function(groupIndex: number): any[] {
      const items = _.cloneDeep(this.group.arrayItems);
      let resolvedItems: any[] = [];
      items.forEach((row: any) => {
        let resolvedRow: any[] = [];
        row = JSON.parse(
          JSON.stringify(row).replace(/__arrayGroup[0-9]/g, () => `${(this.group as any).variable}.${groupIndex}`)
        );
        row.pageItems.forEach((item: any) => {
          item.variable = `${(this.group as any).variable}.${groupIndex}.${item.variable}`;
          // @TODO: remove the below __arrayGroup reference
          item = JSON.parse(
            JSON.stringify(item).replace(/__arrayGroup[0-9]/g, () => `${(this.group as any).variable}.${groupIndex}`)
          );
          resolvedRow.push(item);
        });
        const updatedRow = { ...row, pageItems: resolvedRow };
        resolvedItems.push(updatedRow);
      });
      return resolvedItems;
    },
    /**
     * used to initialise empty array for array groups
     */
    _writeArrayGroupVars: function() {
      const {
        prefix: groupVariablePrefix,
        key: groupVariableKey
      } = this.parent._getPrefixAndKey(this.group.variable);
      const initialLength: number = isNaN(this.group.initialArrayLength) ? 1 : this.group.initialArrayLength;
      const initialValue: any[] = this.group.initialValue ? this.group.initialValue : [];
      const initialData = this.parent._getVariable(groupVariablePrefix);
      if(initialLength && initialValue.length === 0) {
        _.range(initialLength).map(() => initialValue.push({}));
      }
      const { prefix, key } = this.parent._getPrefixAndKey(
        groupVariablePrefix
      );
      this.$set(this.parent._getVariable(prefix), key, {
        [groupVariableKey]: initialValue,
        ...initialData
      });
      this.$watch(
        () => this.parent._getVariable(this.group.variable),
        newGroupVariable => {
          if (newGroupVariable && newGroupVariable.length == 0 && initialLength !== 0) {
            const { prefix, key } = this.parent._getPrefixAndKey(
              this.group.variable
            );
            this.$set(this.parent._getVariable(prefix), key, [{}]);
          }
        }, { immediate: true }
      );
    },
    /**
     * to add another row to an arrayGroup
     * @param arrayGroup the arrayGroup details
     */
    addGroupRow: function(arrayGroup: any) {
      const arrayGroupVar = this.parent._getVariable(arrayGroup.variable);
      arrayGroupVar.push({});
    },
    /**
     * to remove a row from an arrayGroup
     * @param arrayGroup the arrayGroup details
     * @param index the index of the array to be removed
     */
    removeGroupRow: function(arrayGroup: any, index: number) {
      const arrayGroupVar: any[] = this.parent._getVariable(
        arrayGroup.variable
      );
      arrayGroupVar.splice(index, 1);
      const { prefix, key } = this.parent._getPrefixAndKey(arrayGroup.variable);
      this.$set(this.parent._getVariable(prefix), key, arrayGroupVar);
    },
    showRemoveRowButton: function(index: number): boolean {
      // v-if="!disabledArrayGroup && !group.disableAddDelete && (initialArrayLength === 0 || groupItemKey > 0)"
      if(this.disabledArrayGroup || this.group.disableAddDelete) return false;
      if(this.initialArrayLength === 0) return true;
      const arrayLength = this.getVariable(this.group.variable).length || 1;
      if(arrayLength > 1 || index > 0) return true;
      return false;
    }
  }
});
